<a *ngIf="selectedMoreFilters.length > 0"  class="clear-filter pr-4" (click) = "resetReport()" href="javascript:void(0)">Clear filters</a>

<a href="javascript:void(0)" class="mb-0 more-filter" (click)="openMoreFilterComponent(moreFilter)" data-direction="right">More filters</a>

<span *ngIf="selectedMoreFilters.length > 0" [ngbPopover]="tooltipContent" triggers="mouseenter:mouseleave" #fil="ngbPopover" placement="bottom" class="filter-count ml-2 popover-text"> {{selectedMoreFilters.length}}</span>

<ng-template  #tooltipContent placement="bottom">
    <ol class="more-filter-apply-tooltip">
      <li *ngFor = "let filter_id of selectedMoreFilters">{{moreFiltersByMap[filter_id]}}</li>
    </ol>
</ng-template>


<!--bootstrap modal for more filters -->
<ng-template #moreFilter let-c="close" let-modal>
  <div class="modal-header">
    <h4 class="modal-title">More Filters
      <button type="button" class="close-btn" aria-label="Close" (click)="cancelMoreFilters()">
      <span aria-hidden="true"><i class="nxticon-close nxt-font-16 font-weight-bolder"></i></span>
      </button>
  </h4>
  </div>
  <div class="modal-body">
    <div class="nxt-card position-relative" *ngFor = " let item of addMoreFiltersList; let i = index;" >

      <!-- Filter By -->
      <mat-form-field class="w-150px mr-4 " [formGroup]="moreFiltersForm"  >
        <mat-select (selectionChange)="resetcondition(item.sq)" formControlName="filter_sq_id_{{item.sq}}" [placeholder]="(moreFiltersForm.controls[item.filterByField].value) ? moreFiltersByMap[moreFiltersForm.controls[item.filterByField].value] : 'Filter by' " #filterBy  floatLabel="never" >
          <input *ngIf="moreFiltersBy.length>5" placeholder="Search" class="mat-input-element mat-select-search-input"
                    (input)="onKey($event.target.value)">
          <ng-container *ngFor="let filter of moreFiltersByFiltered">
            <mat-option *ngIf="filter.id !== 1 && filter.id !== 7"  [value]="filter.id">
              {{ filter.name }}
            </mat-option>
            <ng-container *ngIf="soipFilter == true">
              <mat-option *ngIf="filter.id === 1 || filter.id === 7"  [value]="filter.id">
                {{ filter.name }}
                </mat-option>
            </ng-container>
            <ng-container *ngIf="soipFilter != true">
              <mat-option *ngIf="(filter.id === 1 || filter.id === 7) && hashEnabled === '0'"  [value]="filter.id">
                {{ filter.name }}
                </mat-option>
            </ng-container>
          </ng-container>

        </mat-select>
      </mat-form-field>

      <!-- Condition -->
      <mat-form-field class="w-150px mr-4" [hidden] = "(moreFiltersForm.controls[item.filterByField].value == 4) || (moreFiltersForm.controls[item.filterByField].value == 5 && soipFilter === true) || (moreFiltersForm.controls[item.filterByField].value == 11)|| (moreFiltersForm.controls[item.filterByField].value == 12) || (moreFiltersForm.controls[item.filterByField].value == 26) || (moreFiltersForm.controls[item.filterByField].value == 6)" [formGroup]="moreFiltersForm" >
        <mat-select placeholder="Condition" formControlName="filter_sq_cond_{{item.sq}}"  >
          <mat-option [value]="1">Is</mat-option>
          <mat-option [value]="2" *ngIf="moreFiltersForm.controls[item.filterByField].value != 28 && moreFiltersForm.controls[item.filterByField].value != 29">Contains</mat-option>
          <mat-option [hidden]="(moreFiltersForm.controls[item.filterByField].value != 7)" *ngIf="soipFilter==false && page == 'live'" [value]="3">Is not</mat-option>
          <!-- <mat-option [hidden]="(moreFiltersForm.controls[item.filterByField].value != 7)" *ngIf="soipFilter==false && page == 'live'" [value]="5">Starts with</mat-option>
          <mat-option [hidden]="(moreFiltersForm.controls[item.filterByField].value != 7)" *ngIf="soipFilter==false && page == 'live'" [value]="6">Ends with</mat-option> -->
          <!-- <mat-option [hidden]="(moreFiltersForm.controls[item.filterByField].value != 7)" *ngIf="soipFilter==false && page == 'live'" [value]="4">Does not contain</mat-option> -->
        </mat-select>
      </mat-form-field>

      <!-- Input Value -->
      <mat-form-field class="w-200px" [formGroup]="moreFiltersForm" [hidden] = "(moreFiltersForm.controls[item.filterByField].value == 4) || (moreFiltersForm.controls[item.filterByField].value == 5 || (moreFiltersForm.controls[item.filterByField].value == 11) || (moreFiltersForm.controls[item.filterByField].value == 26) || (moreFiltersForm.controls[item.filterByField].value == 6) )" >
          <input matInput formControlName="filter_sq_val_{{item.sq}}" [placeholder]="(moreFiltersForm.controls[item.filterCondField].value == 2 ) ? commaSeparateVal : signleVal" required >
      </mat-form-field>

      <!-- Status select -->
      <mat-form-field class="w-200px" *ngIf = "moreFiltersForm.controls[item.filterByField].value == 4" [formGroup]="moreFiltersForm" >
        <mat-select formControlName="filter_sq_status_val_{{item.sq}}" multiple panelClass="multi-select-dropdown" required >
          <mat-select-trigger>
          {{ moreFiltersForm.controls[item.filterStatusValField].value ? allStatusListMap[moreFiltersForm.controls[item.filterStatusValField].value[0]] : '' }}
          <span *ngIf="moreFiltersForm.controls[item.filterStatusValField].value?.length > 1" class="example-additional-selection">
            (+{{moreFiltersForm.controls[item.filterStatusValField].value.length - 1}} others)
          </span>
          </mat-select-trigger>
          <mat-option (click)="toggleAllSelection( $event, item.sq )" value="all" >All</mat-option>
          <mat-option *ngFor = "let item2 of allStatusList" [value]="item2.value" (click)="toggleStatusSelect(item.sq, item2.value)"> {{item2.itemName}} </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="w-150px mr-4" *ngIf = "moreFiltersForm.controls[item.filterByField].value == 6" [formGroup]="moreFiltersForm" >
        <mat-select	formControlName="filter_sq_channel_val_{{item.sq}}" required >
          <input placeholder="Search" class="mat-input-element mat-select-search-input"
                    (input)="onKey2($event.target.value)">
          <mat-option *ngFor = "let channel of channelListFilter" [value]="channel.value"> {{channel.text}} </mat-option>
        </mat-select >
      </mat-form-field>

      <!-- Tags select -->
      <!-- <mat-form-field class="w-150px mr-4" *ngIf = "moreFiltersForm.controls[item.filterByField].value == 5 && soipFilter==false" [formGroup]="moreFiltersForm" >
        <mat-select	formControlName="filter_sq_tag_val_{{item.sq}}" required >
          <input *ngIf="tagItems.length" placeholder="Search" class="mat-input-element mat-select-search-input"
                    (input)="onKey3($event.target.value)">
          <mat-option *ngIf="!tagItemsFilter || !tagItemsFilter?.length" class="no-option2" disabled ><span class="nxticon-information1 nxt-font-19"></span> <span>No data available</span></mat-option>
          <ng-container *ngIf="tagItemsFilter.length">
            <mat-option *ngFor = "let tag of tagItemsFilter" [value]="tag.value"> {{tag.text}} </mat-option>
          </ng-container>
        </mat-select >
      </mat-form-field> -->

      <mat-form-field class="w-150px mr-4" *ngIf="moreFiltersForm.controls[item.filterByField].value == 5 && soipFilter === false" [formGroup]="moreFiltersForm">
        <input matInput formControlName="filter_sq_tag_val_{{item.sq}}" required>
      </mat-form-field>

      <mat-form-field class="w-150px mr-4" *ngIf = "moreFiltersForm.controls[item.filterByField].value == 5 && soipFilter==true" [formGroup]="moreFiltersForm" >
        <mat-select	formControlName="filter_sq_tag_val_{{item.sq}}" required >
          <input *ngIf="tagItems.length" placeholder="Search" class="mat-input-element mat-select-search-input"
                    (input)="onKey3($event.target.value)">
          <mat-option *ngIf="!tagItemsFilter || !tagItemsFilter?.length" class="no-option2" disabled ><span class="nxticon-information1 nxt-font-19"></span> <span>No data available</span></mat-option>
          <ng-container *ngIf="tagItemsFilter.length">
            <mat-option *ngFor = "let tag of tagItemsFilter" [value]="tag"> {{tag}} </mat-option>
          </ng-container>
        </mat-select >
      </mat-form-field>

      <!-- Bot opens -->
      <mat-form-field class="w-100px mr-4" style="margin-left: 30px;" *ngIf = "moreFiltersForm.controls[item.filterByField].value == 11 || ( moreFiltersForm.controls[item.filterByField].value == 4 && showOpensFilter && soipFilter != true)" [formGroup]="moreFiltersForm" >
        <mat-select formControlName="filter_sq_openType_val_{{item.sq}}" required >
          <mat-option value="1" selected> All Open </mat-option>
          <!-- <mat-option value="1" > All Open </mat-option> -->
          <mat-option value="2"> User Open </mat-option>
          <mat-option value="3"> Machine Open </mat-option>
        </mat-select >
      </mat-form-field>

      <!-- Mailt Type select -->
      <mat-form-field class="w-100px mr-4" style="margin-left: 30px;" *ngIf = "moreFiltersForm.controls[item.filterByField].value == 26 " [formGroup]="moreFiltersForm" >
        <mat-select formControlName="filter_sq_mailType_val_{{item.sq}}" required >
          <mat-option value="0" selected> All </mat-option>
          <!-- <mat-option value="1" > All Open </mat-option> -->
          <mat-option value="1"> AMP </mat-option>
          <mat-option value="2"> HTML </mat-option>
        </mat-select >
      </mat-form-field>

      <span *ngIf="addMoreFiltersList.length > 1" class="pointer ml-3 more-filter-deleteicon" (click) = "onDeleteMoreFilterClick( moreFiltersForm, item.sq )" >
        <!-- <img [src]  = "deleteIconImg"> -->
        <i class="nxticon-delete-new nxt-font-20 font-color-cobaltBlue"></i>
      </span>

    </div>

    <div [ngClass] = "( ( addMoreFiltersListCounts - deletedMoreFilters.length ) == 0 ) ? ' no-row-filter' : '' " class="add-fliter-btn mt-2 mb-2" >
      <button type="button" *ngIf = "( ( addMoreFiltersListCounts - deletedMoreFilters.length ) <= (moreFiltersByMaster.length - 1) ) " class="btn btn-secondary" (click) = "onAddMoreFilterClick(moreFiltersForm)" ><i class="nxticon-add-new mr-2"></i>Add filter</button>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="applyMoreFilters( moreFiltersForm ) " >Apply</button>
    <!-- <button type="button" class="btn btn-secondary" (click)="cancelMoreFilters()">Cancel</button> -->
  </div>
</ng-template>
